import { lazy } from 'react';

import { Loadable } from '../../../../utils';

export const UserAccount = Loadable(lazy(() => import('../components/Account')));
